<template>
  <div class="search__wrp">
    <div class="search__input">
      <span class="form__input-wrp">
        <span class="form__input-append-in">
          <button class="btn-icon search__btn" @click="showAllResult">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.33 10.007l4.273 4.273a.502.502 0 0 1 .005.709l-.585.584a.499.499 0 0 1-.709-.004L10.046 11.3a6.278 6.278 0 1 1 1.284-1.294zm.012-3.729a5.063 5.063 0 1 0-10.127 0 5.063 5.063 0 0 0 10.127 0z"
              />
            </svg>
          </button>
        </span>
        <input
          placeholder="搜索内容"
          type="search"
          class="form__input"
          v-model="keyword"
          v-on:keyup.enter.prevent="onEnter"
          v-on:keyup.up.prevent="selectItem(-1)"
          v-on:keyup.down.prevent="selectItem(1)"
          v-on:blur="onBlur"
        />
      </span>
    </div>
    <div class="reco-list__wrp" v-show="articles.length">
      <ul class="reco__list">
        <li class="reco__item" v-for="(article,index) in articles" :key="article.id">
          <router-link
            :to="'/doc/'+article.projectCode+'/'+article.itemCode"
            class="reco-item__link"
            :class="{'active':index == selection}"
          >
            <div class="reco-item__hd">
              <h5 v-html="article.itemName"></h5>
              <span class="reco-item__group">{{article.projectName}}</span>
            </div>
            <div class="reco-item__bd">
              <div class="reco-item__desc" v-html="article.brief"></div>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="show-more" v-show="showMore">
        <a href="javascript:void(0);" @click="showAllResult" class="reco-item__link">查看更多</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String
  },
  data() {
    return {
      number: 1,
      size: 10,
      keyword: this.value,
      articles: [],
      selection: null,
      showMore: false
    };
  },
  watch: {
    keyword(val) {
      if (val) {
        this.search(val);
      } else {
        this.resetResultList();
      }
    }
  },
  methods: {
    search() {
      var me = this;
      setTimeout(function() {
        if (!me.searching && me.keyword) {
          me.searching = true;
          me.$ajax({
            url: "/api/help/article/search",
            params: {
              keyword: me.keyword,
              number: me.number,
              size: me.size
            }
          })
            .then(function(res) {
              me.searching = false;
              if (res.success) {
                me.articles = res.data.content;
                me.selection = null;
                me.showMore = me.size < res.data.totalElements;
              }
            })
            .catch(function() {
              me.searching = false;
            });
        }
      }, 100);
    },
    resetResultList() {
      var me = this;
      me.articles = [];
      me.selection = null;
    },
    onEnter() {
      var me = this,
        keyword = me.keyword,
        selected,
        path;
      if (keyword) {
        if (me.selection != null) {
          selected = me.articles[me.selection];
          me.resetResultList();
          path = "/doc/" + selected.projectCode + "/" + selected.itemCode;
          if (path != me.$route.fullPath) {
            me.$router.push(path);
          }
        } else if (keyword != me.$route.query.keyword) {
          me.showAllResult();
        }
      }
    },
    showAllResult() {
      var me = this,
        keyword = me.keyword;
      if (keyword) {
        me.resetResultList();
        me.$router.push({
          path: "/doc/search",
          query: {
            keyword
          }
        });
      }
    },
    highlightItems(articles) {
      var search = this.keyword,
        exp = new RegExp(search, "g"),
        rep = "<em>" + search + "</em>";
      articles.forEach(article => {
        article.itemName = article.itemName.replace(exp, rep);
        article.brief = article.brief.replace(exp, rep);
      });
      return articles;
    },
    selectItem(step) {
      var me = this,
        index,
        articles = me.articles;
      if (me.selection == null) {
        if (step < 0) {
          index = articles.length - 1;
        } else {
          index = 0;
        }
      } else {
        index = me.selection + step;
        if (index < 0) {
          index = articles.length - 1;
        } else if (index >= articles.length) {
          index = 0;
        }
      }

      // TODO scroll-to-item
      me.selection = index;
    },
    onBlur() {
      var me = this;
      setTimeout(function() {
        me.resetResultList();
      }, 200);
    }
  }
};
</script>

<style>
.search__wrp {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  position: relative;
}

.reco-list__wrp {
  position: absolute;
  z-index: 99;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 10px 0;
  left: -1px;
  right: -1px;
  top: 101%;
  max-height: 500px;
  overflow-y: auto;
}

.reco-item__link {
  display: block;
  transition: all 0.3s;
  padding: 16px;
}

.reco-item__link:hover {
  background-color: var(--color-hover);
}

.reco-item__link.active {
  background-color: var(--color-bg);
}

.reco-item__hd {
  margin-bottom: 4px;
}

.reco-item__hd h5 {
  display: inline-block;
  font-size: 14px;
  vertical-align: middle;
}

.reco-item__hd .reco-item__group {
  font-size: 13px;
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  border-radius: 3px;
  border: 1px solid #222;
  vertical-align: middle;
  display: inline-block;
  transform: scale(0.84);
}

.reco-item__desc {
  color: #888;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 1.42;
  max-height: 2.84em;
}

.show-more a,
.show-more a:hover {
  color: #888;
}

.search__wrp .form__input-append-in {
  padding: 0;
  font-size: 0;
  line-height: 1.6;
}

.search__wrp .form__input {
  padding-right: 46px;
  height: 45px;
  border: none;
  caret-color: var(--color-primary);
}
</style>